import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { classNames } from 'utils/utils'

import 'styles/ChecComponents.css'

export default class ChecActionDrawer extends Component {
  // eslint-disable-next-line react/static-property-placement
  static defaultProps = {
    wrapperClassName: '',
    className: '',
    visible: true,
  }

  // eslint-disable-next-line react/static-property-placement
  static propTypes = {
    wrapperClassName: PropTypes.string,
    className: PropTypes.string,
    visible: PropTypes.bool,
    children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  }

  toggleBodyClass = () => {
    const { visible } = this.props

    if (visible) {
      document.body.classList.add('action-drawer-visible')
    } else {
      document.body.classList.remove('action-drawer-visible')
    }
  }

  componentDidMount() {
    this.toggleBodyClass()
  }

  componentDidUpdate() {
    this.toggleBodyClass()
  }

  render() {
    const { wrapperClassName, className, children, visible } = this.props

    return (
      <>
        <div className="chec-action-drawer-block" />
        <div
          className={classNames('chec-action-drawer-wrapper', wrapperClassName)}
        >
          <div
            className={classNames('chec-action-drawer', className)}
            hidden={!visible}
          >
            {children}
          </div>
        </div>
      </>
    )
  }
}
